var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{staticStyle:{"color":"white"},attrs:{"span":6}},[_vm._v(".")]),_c('el-col',{attrs:{"span":12}},[_c('img',{staticClass:"error_img",attrs:{"src":require("../assets/imgs/url_error.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }